export default "__VITE_ASSET__CptgnavY__"